import { isMobileDevice } from "../utility/utils";
class tdForm {
  constructor(formEl) {
    this.block = formEl;

    if (!this.block || !this.block.closest('.newsletter_wrap')) {
      return;
    }

    this.setFormEl();

    // Init the form on initial render and ajax reinitialization
    jQuery(document).on('gform_post_render', (event, form_id, current_page) => {
      if(this.formID == form_id){
        setTimeout(() => {
          this.init();
        }, 1);
      }
    });
  }

  init() {
    this.setFormEl();
    this.fields = this.getFieldData();
    this.submit = this.block.querySelector('button[type="submit"], input[type="submit"]');
    this.setUI();
    this.handleInputActiveState();
    this.bindSubmitStateWatcher();
    this.updateSubmitState();
  }

  setFormEl() {
    this.form = this.block.querySelector("form");
    this.formID = this.form.getAttribute("data-formid");
  }

  getFieldData(fields = false) {
    fields = fields ? fields : this.block.querySelectorAll(".gfield:not(.gsection, .gfield--type-section, .gfield--type-html, .gfield_html");
    let fieldsData = [];
    fields.forEach((field) => {
      let fieldData = {};

      fieldData.wrapper = field;

      fieldData.input = field.querySelector(
        ".ginput_container textarea, .ginput_container input, .ginput_container select"
      );

      fieldData.label = field.querySelector(".gfield_label");
      
      fieldData.labelString = fieldData.label ? fieldData.label.innerText : "";
      if(fieldData.labelString.includes('*')){
        fieldData.labelString = fieldData.labelString.replace('*', '<span class="required">*</span>');  
      }

      if (fieldData.wrapper && fieldData.wrapper.classList.contains("gfield--type-html")) {
        fieldData.type = "html";
      } else if (fieldData.input.classList.contains("datepicker")) {
        fieldData.type = "date";
      } else if (fieldData.input.classList.contains("textarea")) {
        fieldData.type = "textarea";
      } else if (fieldData.input.classList.contains("gfield_select")) {
        fieldData.type = "select";
      } else {
        fieldData.type = "text";
      }

      fieldsData.push(fieldData);
    });

    return fieldsData;
  }

  setUI() {
    this.fields.forEach((field) => {
      let uiMarkup = null;

      // Select Inputs
      if(field.type && field.type === "select") {
        uiMarkup = this.selectUI(field);
      }

      if(uiMarkup && field.wrapper){
        field.wrapper.appendChild(uiMarkup);
      }
    }); 
  }

  selectUI(field) {
    const selectOptions = field.input ? field.input.querySelectorAll('option') : null;

    if(!selectOptions) return;

    // Select Wrapper
    const wrapper = document.createElement("div");
    wrapper.classList.add("td_form_ui");
    wrapper.classList.add("td_select_ui");

    // Select Trigger
    const trigger = document.createElement("div");
    trigger.classList.add('td_select_ui__trigger');
    trigger.setAttribute('tabindex', '1');

    // Select Trigger Text Span El
    const triggerText = document.createElement("span");
    triggerText.classList.add('td_select_ui__trigger_text');
    triggerText.innerHTML = field.labelString;
    trigger.appendChild(triggerText);

    // Select Trigger Icon
    const triggerIcon = document.createElement("span");
    triggerIcon.classList.add('td_select_ui__trigger_icon');
    triggerIcon.classList.add('icon_btn');
    triggerIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none"><line x1="7.5" y1="0.5" x2="7.5" y2="15.5" stroke="#1B3548"/><line x1="15" y1="8" x2="-4.37114e-08" y2="8" stroke="#1B3548"/></svg>';
    trigger.appendChild(triggerIcon);

    // Select Options
    const options = document.createElement("ul");
    options.classList.add('td_select_ui__options');
    const optionsID = 'td_select__options_' + Math.floor(Math.random() * 1000000);
    options.setAttribute('id', optionsID);

    // Select Option
    selectOptions.forEach((option) => {
      const optionEl = document.createElement("li");
      optionEl.classList.add('td_select_ui__option');

      const optionButton = document.createElement("div");
      optionButton.classList.add('td_select_ui__option_button');
      optionButton.innerHTML = option.innerHTML;
      optionButton.setAttribute('data-value', option.value);
      optionButton.setAttribute('tabindex', '1');

      optionEl.appendChild(optionButton);
      options.appendChild(optionEl);
    });

    // Accessibility
    options.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-controls', optionsID);
    field.label.classList.add('td_select_ui__label');
    field.label.classList.add('hidden');

    // Put it together
    wrapper.appendChild(trigger);
    wrapper.appendChild(options);

    // Check if on load there is a selected option
    const selectedOption = field.input.querySelector('option[selected]') ? field.input.querySelector('option[selected]').innerHTML : null;
    if(selectedOption){
      triggerText.innerHTML = selectedOption;
      field.label.classList.remove('hidden');
    }

    // Toggle Event
    const toggleSelect = () => {
      if(isMobileDevice()){
        field.input.classList.add('mobile_active');
        field.input.style.display = 'block';
        field.input.focus();

        // Listen for change event to update custom UI after selection
        field.input.addEventListener('change', function() {
          const selectedOption = field.input.options[field.input.selectedIndex].text;
          triggerText.innerHTML = selectedOption;
          field.input.style.display = 'none'; // Hide native select again
        });
      }
      else {
        wrapper.classList.toggle("active");
        options.setAttribute('aria-hidden', wrapper.classList.contains('active') ? 'false' : 'true');
        options.classList.toggle("active");
        trigger.classList.toggle("active");
      }
    }

    // Close Event
    const closeOptions = () => {
      wrapper.classList.remove("active");
      options.classList.remove("active");
      options.setAttribute('aria-hidden', 'true');
      trigger.classList.remove("active");
    }

    // Selection Event
    const selectOption = (option, field) => {
      if(option.classList.contains('td_select_ui__option_button')) {
        const value = option.getAttribute('data-value');
        field.input.value = value;
        triggerText.innerHTML = option.innerHTML;

        if(field.label.classList.contains('hidden')){
          field.label.classList.remove('hidden');
        }
        
        closeOptions();
      }
    }

    // Toggle Select on Trigger Click
    trigger.addEventListener("click", () => {
      toggleSelect();
    });

    // Toggle Select when user clicks the enter key on the trigger
    trigger.addEventListener("keydown", (e) => {
      if(e.key === 'Enter'){
        toggleSelect();
      }
    });

    // Close the options if clicked outside of the select
    document.addEventListener("click", (e) => {
      if (!wrapper.contains(e.target)) {
        closeOptions();
      }
    });

    // Set the field.input value to the selected option and close the options
    options.addEventListener("click", (e) => {
      selectOption(e.target, field);
    });

    // Set the field.input value on selected option with the enter key
    options.addEventListener("keydown", (e) => {
      if(e.key === 'Enter'){
        selectOption(e.target, field);
      }
    });

    // Watch for focus change. If focus is not in the select and it's open, close it
    document.addEventListener('focus', function(event) {
      if (!wrapper.contains(event.target) && wrapper.classList.contains('active')) {
        closeOptions();
      }
    }, true);

    // Hide the select input
    field.input.style.display = 'none';

    return wrapper;
  }

  bindSubmitStateWatcher() {
    if (!this.form || this.requiredFieldsWatcherBound) return;

    this.requiredFieldsWatcherBound = true;

    this.form.addEventListener('input', () => this.updateSubmitState());
    this.form.addEventListener('change', () => this.updateSubmitState());
  }

  updateSubmitState() {
    if (!this.form || !this.submit) return;

    const requiredFields = [...this.form.querySelectorAll('.gfield_contains_required input, .gfield_contains_required textarea, .gfield_contains_required select')]
      .filter((field) => {
        if (!field || field.disabled) return false;

        const type = field.type;
        if (type === 'checkbox' || type === 'radio') {
          return field.checked;
        }

        return String(field.value || '').trim().length > 0;
      });

    const allRequiredFilled = this.form.querySelectorAll('.gfield_contains_required').length
      ? requiredFields.length === this.form.querySelectorAll('.gfield_contains_required input, .gfield_contains_required textarea, .gfield_contains_required select').length
      : true;

    this.submit.disabled = !allRequiredFilled;
    this.submit.setAttribute('aria-disabled', String(!allRequiredFilled));
  }

  handleInputActiveState() {
    this.fields.forEach((field, index) => {
      if (!field.initialized) {
        field.initialized = true;

        this.checkSelectPlaceholderPresence(field);

        this.prepPlaceholderAttr(field);

        this.setInputActiveState(field); // run on load

        if (field.input) {
          field.input.addEventListener("focus", () => {
            field.input.classList.add("focus");
            this.setInputActiveState(field);
            this.setPlaceholderState(field);
          });
          field.input.addEventListener("change", () => {
            this.setInputActiveState(field);
            this.setPlaceholderState(field);
          });
          field.input.addEventListener("focusout", () => {
            field.input.classList.remove("focus");
            this.setInputActiveState(field);
            this.setPlaceholderState(field);
          });
        }
      }
    });
  }

  setInputActiveState(field) {
    const isFocused = field.input.classList.contains("focus");

    if (isFocused || field.input.value) {
      field.wrapper.classList.add("input_initiated");
    } else {
      field.wrapper.classList.remove("input_initiated");
    }

    // Select Field Specific
    // Check if selected option is a placeholder option and equal to the label
    if (field.type == "select") {
      const placeholderOption = field.input.querySelector("option.gf_placeholder");
      if (placeholderOption && !field.input.value) {
        if (placeholderOption.innerHTML == field.label.innerText) {
          field.wrapper.classList.add("hide_label");
        }
      } else if (field.wrapper.classList.contains("hide_label")) {
        field.wrapper.classList.remove("hide_label");
      }
    }
  }

  setPlaceholderState(field) {
    const placeholder = field.input.getAttribute("data-placeholder");

    if (placeholder) {
      const isFocused = field.input.classList.contains("focus");

      if (isFocused && !field.input.value) {
        field.input.setAttribute("placeholder", placeholder);
      } else {
        field.input.setAttribute("placeholder", "");
      }
    }
  }

  prepPlaceholderAttr(field) {
    const placeholder = field.input.getAttribute("placeholder");

    if (placeholder) {
      field.input.classList.add("has_placeholder");
      field.input.setAttribute("data-placeholder", placeholder);
      field.input.removeAttribute("placeholder");
    }
  }

  checkSelectPlaceholderPresence(field) {
    if (field.type == "select") {
      const placeholderOption = field.input.querySelector("option.gf_placeholder");

      if (!placeholderOption) {
        field.wrapper.classList.add("force_input_initiated");
      }
    }
  }
}

const InitForm = () => {
  const forms = document.querySelectorAll(".site-footer .newsletter_wrap .gform_wrapper");
  if (forms) {
    forms.forEach((formEl) => {
      formEl.formButtons = new tdForm(formEl);
    });
  }
};

export { InitForm };
